"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
class InputEvalEvent {
    constructor(withReasons, context, key, value, defValue, // default is a reserved keyword in this context.
    version, variation, trackEvents, prereqOf, reason, debugEventsUntilDate, excludeFromSummaries, samplingRatio = 1) {
        this.withReasons = withReasons;
        this.context = context;
        this.key = key;
        this.samplingRatio = samplingRatio;
        this.kind = 'feature';
        this.creationDate = Date.now();
        this.value = value;
        this.default = defValue;
        if (version !== undefined) {
            this.version = version;
        }
        if (variation !== undefined) {
            this.variation = variation;
        }
        if (trackEvents !== undefined) {
            this.trackEvents = trackEvents;
        }
        if (prereqOf !== undefined) {
            this.prereqOf = prereqOf;
        }
        if (reason !== undefined) {
            this.reason = reason;
        }
        if (debugEventsUntilDate !== undefined) {
            this.debugEventsUntilDate = debugEventsUntilDate;
        }
        if (excludeFromSummaries !== undefined) {
            this.excludeFromSummaries = excludeFromSummaries;
        }
    }
}
exports.default = InputEvalEvent;
//# sourceMappingURL=InputEvalEvent.js.map